import React from 'react'
import classNames from 'classnames'

interface IconProps {
  classes?: string
  active?: boolean
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
  heapInteraction?: string
}

export const PrevChevron = ({
  classes = '',
  active,
  size = 'large',
  heapInteraction
}: IconProps) => {
  const iconClass = classNames(classes, {
    'relative swiper-prev mr-4 text-[0px] text-transparent': true,
    'w-6 h-6': size == 'xsmall',
    'w-8 h-8': size == 'small',
    'w-10 h-10': size == 'medium',
    'w-12 h-12': size == 'large',
    'w-14 h-14': size == 'xlarge'
  })

  return (
    <button
      aria-label='Navigate to previous slide'
      className={iconClass}
      data-interaction={heapInteraction}
      data-testid='PrevChevron'
    >
      <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'>
        <circle
          cx='16'
          cy='16'
          r='16'
          fill={active ? '#2B4FB9' : '#E5E5E5'}
          data-testid='PrevChevron-circle'
        />
        <path
          data-testid='PrevChevron-path'
          stroke={active ? '#fff' : 'silver'}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeMiterlimit='10'
          strokeWidth='2'
          d='m17.457 21.267-5.2-5.334 5.2-5.333'
        />
      </svg>
    </button>
  )
}
export const NextChevron = ({
  classes = '',
  active,
  size = 'small',
  heapInteraction
}: IconProps) => {
  const iconClass = classNames(classes, {
    'relative swiper-next mr-4 text-[0px] text-transparent': true,
    'w-6 h-6': size == 'xsmall',
    'w-8 h-8': size == 'small',
    'w-10 h-10': size == 'medium',
    'w-12 h-12': size == 'large',
    'w-14 h-14': size == 'xlarge'
  })
  return (
    <button
      aria-label='Navigate to next slide'
      className={iconClass}
      data-interaction={heapInteraction}
      data-testid='NextChevron'
    >
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' fill='none'>
        <circle
          data-testid='NextChevron-circle'
          cx='16'
          cy='16'
          r='16'
          fill={active ? '#2B4FB9' : '#E5E5E5'}
          transform='rotate(180 16 16)'
        />
        <path
          data-testid='NextChevron-path'
          stroke={active ? '#fff' : 'silver'}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeMiterlimit='10'
          strokeWidth='2'
          d='m14.257 10.6 5.2 5.333-5.2 5.334'
        />
      </svg>
    </button>
  )
}
